import { FormHelperText, styled } from '@ori-ui/mui';
import type { FC } from 'react';

import { Localization } from '../../Localization';
import { defaultTranslations } from '../../constants/defaultTranslations_simplified-registration-BrandPartner';
import type { IErrorData } from '../../contexts';
import { TranslationKey } from '../../models';
import { getErrorLocalizationByCode } from '../../utils';

export const FormErrorSummary = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: theme.spacing(3),
}));

export const StyledSubmitError = styled(FormHelperText)(({ theme }) => ({
  fontSize: '14px',
  textAlign: 'left',
  fontStyle: 'italic',
  marginLeft: theme.spacing(1),
}));

const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.error.main,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.error.main,
    textDecoration: 'underline',
  },
}));

interface FormValidationSummaryProps {
  invalidPropertyErrors?: IErrorData[];
  customerServiceUrl?: string;
}

export const FormValidationSummary: FC<FormValidationSummaryProps> = (props) => {
  const { invalidPropertyErrors, customerServiceUrl } = props;
  const isInvalidPropertyErrors = Boolean(invalidPropertyErrors?.length && invalidPropertyErrors.length > 0);

  if (!isInvalidPropertyErrors) {
    return null;
  }

  return (
    <FormErrorSummary>
      {invalidPropertyErrors?.map((notPropertyError) => (
        <StyledSubmitError
          key={notPropertyError.errorCode}
          error
        >
          <Localization
            {...getErrorLocalizationByCode(notPropertyError.errorCode)}
            values={{
              customerServiceLink: (
                <StyledLink
                  href={customerServiceUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Localization
                    id={TranslationKey.customerServiceLinkLabel}
                    defaultMessage={defaultTranslations.customerServiceLinkLabel}
                  />
                </StyledLink>
              ),
            }}
          />
        </StyledSubmitError>
      ))}
    </FormErrorSummary>
  );
};
